"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _index = _interopRequireDefault(require("../../reducers/index.js"));

var _galleryActions = require("../../actions/galleryActions.js");

var _galleryContainerNew = _interopRequireDefault(require("./galleryContainerNew.js"));

var _utils = _interopRequireDefault(require("../../utils"));

var _WixSdkWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/WixSdkWrapper"));

var _videoActionTypes = _interopRequireDefault(require("../../constants/videoActionTypes"));

var _videoMiddleware = _interopRequireDefault(require("../item/videos/videoMiddleware"));

var _videoQueue = require("../item/videos/video-queue");

var _windowWrapper = _interopRequireDefault(require("../../utils/window/windowWrapper"));

var _itemActions = require("@wix/photography-client-lib/dist/src/item/itemActions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ProGallery =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ProGallery, _React$Component);

  function ProGallery(props) {
    var _this;

    _this = _React$Component.call(this) || this;

    if (_utils["default"].isVerbose()) {
      console.count('[OOISSR] proGallery constructor', _windowWrapper["default"].isMock);
    }

    var isSSR = !!_windowWrapper["default"].isMock;
    _this.canRender = !isSSR || props.allowSSR === true; //do not render if it is SSR

    if (_this.canRender) {
      _this.init(props);
    }

    return _this;
  }

  var _proto = ProGallery.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.store && this.store.dispatch && this.props.forceHover === true) {
      this.store.dispatch((0, _galleryActions.toggleHoverPreview)(this.props.forceHover));
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.store && this.store.dispatch && nextProps.forceHover !== this.props.forceHover) {
      this.store.dispatch((0, _galleryActions.toggleHoverPreview)(nextProps.forceHover));
    }
  };

  _proto.init = function init(props) {
    this.domId = props.domId || Math.floor(Math.random() * 10000);

    if (_utils["default"].isVerbose()) {
      console.log('[OOISSR] proGallery init', _windowWrapper["default"].isMock);
    }

    var middlewares = [_reduxThunk["default"], (0, _videoMiddleware["default"])({
      videoQueue: new _videoQueue.VideoQueue(),
      utils: _utils["default"]
    })];
    this.store = (0, _redux.createStore)(_index["default"],
    /* { gallery: { videoPlayMode: videoPlayModes.hover } } */
    {}, _redux.applyMiddleware.apply(void 0, middlewares));
    this.initStoreEvents(this.store);
  };

  _proto.initStoreEvents = function initStoreEvents(store) {
    if (_WixSdkWrapper["default"] && _WixSdkWrapper["default"].addEventListener) {
      _WixSdkWrapper["default"].addEventListener(_WixSdkWrapper["default"].Events.STYLE_PARAMS_CHANGE, function (styleParams) {
        store.dispatch({
          type: _videoActionTypes["default"].videoModeChanged,
          payload: styleParams.numbers.videoPlay
        });
      });
    }
  };

  _proto.render = function render() {
    return this.canRender && _react["default"].createElement("div", {
      id: "pro-gallery-" + this.domId,
      className: "pro-gallery"
    }, _react["default"].createElement(_reactRedux.Provider, {
      store: this.store
    }, _react["default"].createElement(_galleryContainerNew["default"], _extends({}, this.props, {
      domId: this.domId,
      items: this.props.items || [],
      store: this.store,
      watermarkData: this.props.watermarkData,
      settings: this.props.settings || {},
      offsetTop: this.props.offsetTop,
      itemActions: this.props.itemActions ? this.props.itemActions : _itemActions.itemActions
    }))));
  };

  return ProGallery;
}(_react["default"].Component);

exports["default"] = ProGallery;